module.exports = __webpack_public_path__ + "images/sad-e3e6bfac73d26577ec005c8656248417.png";